import React from 'react'
import { getServerSideProps as getServersidePropsHandler } from 'src/pages/affiliates/server'

const Affiliate = () => {
  return <h1>Redirecting ...</h1>
}

export const getServerSideProps = getServersidePropsHandler

Affiliate.pagePathView = '/affiliate'

export default Affiliate
